import { TextField, TextFieldProps } from "@mui/material";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

export function ComoInput({
  primaryColor,
  sx,
  ...props
}: TextFieldProps & { primaryColor?: string }) {
  const { colors: workspace } = useWorkspaceColors();
  const color = primaryColor || workspace.primary_dark;

  return (
    <TextField
      fullWidth
      size="small"
      sx={{
        "& .MuiOutlinedInput-root": {
          fontSize: "0.875rem",
          borderRadius: 2,
          bgcolor: "white",
          "& fieldset": { borderColor: colors.gray300 },
          "&:hover fieldset": { border: `0.5px solid ${color}` },
          "&.Mui-focused fieldset": {
            border: `0.5px solid ${color}`,
            borderLeft: `4px solid ${color}`,
          },
        },
        "& .MuiInputBase-input, & .MuiOutlinedInput-inputMultiline, & textarea":
          {
            color,
            caretColor: color,
          },
        // Override the global theme that paints labels white (because the
        // app's base theme assumes a dark background). On the new light
        // surfaces we need legible labels.
        "& .MuiInputLabel-root": {
          color: `${colors.gray600} !important`,
          fontSize: "0.875rem",
        },
        '& .MuiInputLabel-root[data-shrink="true"]': {
          color: `${colors.gray600} !important`,
          backgroundColor: "white",
          px: 0.5,
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: `${color} !important`,
        },
        "& .MuiInputLabel-root.Mui-disabled": {
          color: `${colors.gray400} !important`,
        },
        "& input::placeholder, & textarea::placeholder": {
          color: colors.gray400,
          opacity: 1,
        },
        ...sx,
      }}
      {...props}
    />
  );
}
